import { useState, useRef } from 'preact/hooks';

import Vendor from './vendor';

const List = ({ data, load, vendorSelected, defaultUnit, directionsUrl }) => {
    const [reset, setReset] = useState();

    const listInnerRef = useRef();

    const onScroll = () => {
        if (listInnerRef.current) {
            let { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            scrollTop = Math.ceil(scrollTop);
            
            if ((scrollTop > 0) && (scrollTop + clientHeight >= scrollHeight)) {
                load();
            }
        }
    };

    const selected = (item) => {
        vendorSelected(item);
        setReset(item);
    }

    return (
        <div onScroll={onScroll}
            ref={listInnerRef} class='flex flex-col overflow-auto' style='height: calc(100vh - 220px);'>
            {data && data.map((item, index) => (
                <div key={index} class='flex border-b border-gray-300 transition-shadow ease-in-out duration-300 shadow-none hover:shadow-xl hover:border-l hover:border-r'>
                    <Vendor
                        item={item}
                        vendorSelected={selected}
                        reset={reset}
                        defaultUnit={defaultUnit}
                        directionsUrl={directionsUrl}
                    />
                </div>
            ))}
        </div>
    )
}

export default List;